import { Box, SxProps, Theme } from '@mui/material';
import React from 'react';
import {
    isLikelyHtmlContent,
    sanitizeTemplatePreviewHtml,
    templatePreviewPlainText,
} from '../../utils/messageTemplateValidation';

interface Props {
    content: string;
    emptyLabel?: string;
    sx?: SxProps<Theme>;
}

/** Renders template body for admin preview — HTML is sanitized and shown without raw tags. */
export const MessageTemplateBodyPreview: React.FC<Props> = ({
    content,
    emptyLabel = '(no preview)',
    sx,
}) => {
    const trimmed = content?.trim() || '';
    if (!trimmed) {
        return (
            <Box sx={sx}>
                {emptyLabel}
            </Box>
        );
    }

    if (isLikelyHtmlContent(trimmed)) {
        return (
            <Box
                sx={{
                    fontSize: 14,
                    lineHeight: 1.5,
                    color: '#334155',
                    '& p': { margin: '0 0 0.75em' },
                    '& p:last-child': { marginBottom: 0 },
                    ...sx,
                }}
            >
                <Box component="div" dangerouslySetInnerHTML={{ __html: sanitizeTemplatePreviewHtml(trimmed) }} />
            </Box>
        );
    }

    return (
        <Box sx={{ whiteSpace: 'pre-wrap', ...sx }}>
            {templatePreviewPlainText(trimmed)}
        </Box>
    );
};
